import { useEffect, useState } from 'react';
import { getUpcomingEvents } from '../services/events';

export default function useCompanyEvents(companyId) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(Boolean(companyId));
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    if (!companyId) {
      setEvents([]);
      setLoading(false);
      return undefined;
    }

    async function loadEvents() {
      setLoading(true);
      setError(null);
      try {
        const response = await getUpcomingEvents(companyId);
        if (!cancelled) setEvents(Array.isArray(response) ? response : []);
      } catch (loadError) {
        if (!cancelled) {
          setEvents([]);
          setError(loadError);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    loadEvents();
    return () => {
      cancelled = true;
    };
  }, [companyId]);

  return { events, setEvents, loading, error };
}
